export const useGeolocation = () => {
  const latitude = sessionStorage.getItem('user_latitude')
  const longitude = sessionStorage.getItem('user_longitude')

  return { latitude, longitude }
}
